import { createFileRoute } from '@tanstack/react-router'
import { PengantarWilayahManager } from '../../../../components/pengantar-wilayah/PengantarWilayahManager'

export const Route = createFileRoute('/platform/desa/$desaId/pengantar-wilayah')({
  component: () => {
    const { desaId } = Route.useParams()
    return <PengantarWilayahManager desaId={desaId} />
  },
})
